import api from "src/apis/api"

// Click-to-call: connects the signed-in agent to the lead via the org's voice
// provider. The call outcome is logged to the timeline asynchronously.
// `provider` (optional) pins which enabled voice provider to use when the org
// has more than one configured for calls.
export async function placeCall(leadId, { provider } = {}) {
  const { data } = await api.post("/api/v1/communications/calls", { lead_id: leadId, provider })
  return data
}

// Fallback for orgs with no voice provider configured: pushes the lead's number
// to the signed-in user's phone, which opens its native dialer. On failure the
// server returns a `code` (e.g. "no_device") the UI maps to a specific toast.
export async function dialViaMobile(leadId) {
  const { data } = await api.post("/api/v1/communications/dial_via_mobile", { lead_id: leadId })
  return data
}
